<template>
    <div class="follow">
        <div :class="['card', !isWeChat && 'active']">
            <div class="title">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/buy-success-icon.png" alt="">
                <span>恭喜你，拼团成功</span>
            </div>
            <p class="txt_1">完成以下两步，就可以享受购买课程的优质服务啦～</p>        
            <div class="step1">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/step1.png" alt="">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/step-1.png" alt="">
            </div >
            <div class="step2">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/step-2.png" alt="">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/step2.png" alt="">
            </div>
            <button :class="[isBrowser && 'active' ]" @click="toApp">立即前往</button>
        </div>
        <browserMask
          imgUrl="https://appd.knowbox.cn/ss/boxParentService/homework/download/downloadPar.png"
          @close="handleToggle"
          v-show="showMask">
        </browserMask>
    </div>
</template>

<script>
import { isIOS, isAndroid, isRunInWeChat, isSpecialAndMobile, isRunInApp } from "@/utils/env";
import download from "@/utils/download";
import browserMask from "@/components/common/browserMask";

export default {
  name: "follow",
  components: {
    browserMask,
  },
  data(){
    return {
      showMask: false,
      isWeChat: isRunInWeChat(),
      isBrowser: !isRunInWeChat() && !isRunInApp(),
    }
  },
  created: function() {
    this.$wxShare({
      title: localStorage.getItem('shareTitle'),
      desc: localStorage.getItem('shareDesc'),
      link: window.location.origin + window.location.pathname + '#/group_buy/h5_detail?' + 'groupInfoId='+ this.groupInfoId +'&groupId='+ this.groupId,
      imgUrl: localStorage.getItem('shareImgUrl')
    })  
  },
  methods: {
    toApp() {
       window.location.href = "https://gio.ren/oBnOZwp";
      // if (isIOS()) {
      //   download.jumpFn("iosnew");
      // } else if (isAndroid()) {
      //   if (isRunInWeChat()) {
      //     this.handleToggle();
      //   } else {
      //     if (isSpecialAndMobile()) {
      //       window.location.href =
      //         "market://details?id=com.knowbox.rc.student.pk";
      //     } else {
      //       download.jumpFn("andnew");
      //     }
      //   }
      // }
    },
    handleToggle() {
      this.showMask = !this.showMask;
    }
  }
};
</script>

<style lang="scss" scoped>
.follow {
  width: 100%;
  height: 100vh;
  background: #d4edff;
  overflow-y: scroll;
  font-weight: bolder;
  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.3rem;
    width: calc(100% - 0.3rem * 2);
    height: 11.43rem;
    background-color: #ffffff;
    border-radius: 0.2rem;
    position: relative;
    .title {
      margin-top: 0.77rem;
      display: flex;
      align-items: center;
      img {
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.17rem;
      }
      span {
        font-family: FZY4JW--GB1-0;
        font-size: 0.44rem;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #75c9ff;
      }
    }
    .txt_1 {
      margin-top: 0.24rem;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      line-height: 0.28rem;
      height: 0.28rem;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #919294;
      padding: 0 0.94rem;
      text-align: center;
      line-height: 0.46rem;
    }
    .step1 {
      display: flex;
      margin-top: 1.45rem;
      img:nth-child(1) {
        width: 1.7rem;
        height: 1.44rem;
        margin-right: 0.62rem;
      }
      img:nth-child(2) {
        width: 3.57rem;
        height: 1.38rem;
      }
    }
    .step2 {
      display: flex;
      margin-top: 1.16rem;
      align-items: center;
      img:nth-child(1) {
        width: 3.12rem;
        height: 1.87rem;
        margin-right: 0.44rem;
      }
      img:nth-child(2) {
        width: 2.23rem;
        height: 1.44rem;
      }
    }
    button {
      position: absolute;
      left:50%;
      transform: translateX(-50%);
      bottom: .6rem;
      margin-top: 1.5rem;
      width: 5.7rem;
      height: 1rem;
      background-color: #85cdf8;
      border-radius: 0.5rem;
      font-family: PingFangSC-Medium;
      font-size: 0.34rem;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
      &.active {
        position: absolute;
        left:50%;
        transform: translateX(-50%);
        bottom: 2.6rem;
      }
    }
  }
  .active{
    height: 13.43rem;
  }
}
</style>